/**
 * Processes an input object by inspecting its properties and modifying array properties
 * that are empty by replacing them with a `null` value. Leaves all other properties unchanged.
 *
 * @template T - A generic object type that extends from `object`.
 * @param {T} params - An object containing the properties to be processed.
 * @returns {T} - A new object with empty arrays replaced by `null` and all other properties preserved.
 */
export const prepareRequest = <T extends object>(params: T): T => {
  const result: Record<string, unknown> = {};

  Object.keys(params).forEach((key: string): void => {
    const typedKey = key as keyof T;

    if (Array.isArray(params[typedKey]) && params[typedKey].length === 0) {
      result[key] = null;
    } else {
      result[key] = params[typedKey];
    }
  });

  return result as unknown as T;
};
